export const handleMultiChoiceFilter = ({ filterOption, selectedFilters }) => {
  if (selectedFilters.includes(filterOption.target_params.queryParams)) {
    return selectedFilters.filter((param) => param !== filterOption.target_params.queryParams);
  }
  return [...selectedFilters, filterOption.target_params.queryParams];
};

export const handleSingleChoiceFilter = ({ filterOption, selectedFilters }) => {
  const param = filterOption.target_params.queryParams;
  const key = param.split('=')[0];

  // Filter out the param that is a match to the filterOption
  if (selectedFilters.includes(param)) {
    return selectedFilters.filter((p) => p !== param);
  }

  // Filter out any params with the same key as the filterOption.
  const params = selectedFilters.filter((p) => !p.includes(`${key}=`));
  return [...params, param];
};

export const setParams = (filterData) =>
  filterData.type === 'SINGLE_CHOICE'
    ? handleSingleChoiceFilter(filterData)
    : handleMultiChoiceFilter(filterData);
